export const publicRoutes = {
  sharedChat: '/shared-chat',
};

export const authRoutes = {
  auth: '/auth',
  login: '/auth/login',
  signup: '/auth/signup',
  verifyEmail: '/auth/verify-email',
  invitationSignup: '/invitations/accept/[id]/[uuid]/signup',
  invitationSignIn: '/invitations/accept/[id]/[uuid]/signin',
  verifyInvitationEmail: '/invitations/accept/[id]/[uuid]/verify-email',
  callback: '/auth/callback',
  forgotPassword: '/auth/forgot-password',
  maintenance: '/maintenance',
};

export const authorizedRoutes = {
  insights: '/orth/insights',
  subscription: '/orth/subscription',
  subscriptionUpgrade: '/orth/subscription?upgrade=true',
  teamSubscription: '/team-subscription',
  mobileSubscribe: '/mobileSubscribe',
  mobileCallBack: '/mobileCallBack',
  /** Stripe success return for all web purchases (individual + team). */
  subscriptionCallBack: '/subscriptionCallBack',
  /** @deprecated Fallback for in-flight checkout sessions; redirects to subscriptionCallBack. Delete after release. */
  webCallBack: '/webCallBack',
  /** @deprecated Fallback for in-flight checkout sessions; redirects to subscriptionCallBack. Delete after release. */
  plusCallBack: '/plusCallBack',
  editFarmLocation: '/edit-farm-location',
  addFarm: '/add-farm',
};

/**
 * Routes that exist only to sell or manage a subscription. Blocked in the auth
 * middleware for Enterprise accounts, whose contract is handled outside the app
 * entirely (see `shared/plan.ts`).
 */
export const paymentRoutes = [
  authorizedRoutes.subscription,
  authorizedRoutes.teamSubscription,
  authorizedRoutes.mobileSubscribe,
  authorizedRoutes.mobileCallBack,
  authorizedRoutes.subscriptionCallBack,
  authorizedRoutes.webCallBack,
  authorizedRoutes.plusCallBack,
];

export const appRoutes = {
  orth: '/orth',
  history: '/orth/history',
  setting: '/setting',
  personalize: '/personalize',
  ...authorizedRoutes,
};

export const routes = {
  onboarding: '/onboarding',
  ...publicRoutes,
  ...authRoutes,
  ...appRoutes,
};
